(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["galea-366-swatches"] && !Shopify.designMode) return;
  try {
    function galea366Price(picker,variant){
  const info=picker.closest('.Product__Info');
  const prices=info&&info.querySelector('.ProductMeta__PriceList');
  if(!prices)return;
  prices.style.display=variant?'':'none';
  if(!variant)return;
  const formatter=new Intl.NumberFormat(document.documentElement.lang||'es-ES',{style:'currency',currency:picker.dataset.currency||'EUR',minimumFractionDigits:0,maximumFractionDigits:2});
  const current=document.createElement('span');
  current.className='ProductMeta__Price Price Text--subdued u-h4';
  current.textContent=formatter.format(Number(variant.price)/100);
  prices.replaceChildren(current);
  if(Number(variant.compare_at_price)>Number(variant.price)){
    current.classList.add('Price--highlight');
    const previous=document.createElement('span');
    previous.className='ProductMeta__Price Price Price--compareAt Text--subdued u-h4';
    previous.textContent=formatter.format(Number(variant.compare_at_price)/100);
    prices.appendChild(previous);
  }
}
function galea366InitialPrices(){
  document.querySelectorAll('.Galea366Finishes').forEach(function(picker){
    galea366Price(picker,{price:picker.dataset.initialPrice,compare_at_price:picker.dataset.initialCompare});
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',galea366InitialPrices,{once:true});
else galea366InitialPrices();
window.addEventListener('load',galea366InitialPrices,{once:true});
document.addEventListener('change',function(event){
  if(!event.target.classList.contains('Galea366Radio'))return;
  const picker=event.target.closest('.Galea366Finishes');
  const selected=picker&&picker.querySelector('.ProductForm__SelectedValue');
  if(selected)selected.textContent=event.target.value;
});
document.addEventListener('variant:changed',function(event){
  const picker=event.target.querySelector('.Galea366Finishes');
  if(picker)requestAnimationFrame(function(){galea366Price(picker,event.detail.variant);});
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["galea-bok-swatches"] && !Shopify.designMode) return;
  try {
    function galeaBokInitialPrices() {
  document.querySelectorAll('.GaleaBokFinishes').forEach(function(picker) {
    const info = picker.closest('.Product__Info');
    const price = info && info.querySelector('.ProductMeta__PriceList .Price');
    if (price) price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'es-ES', {
      style: 'currency', currency: picker.dataset.currency || 'EUR'
    }).format(Number(picker.dataset.initialPrice) / 100);
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', galeaBokInitialPrices, { once: true });
} else {
  galeaBokInitialPrices();
}

document.addEventListener('variant:changed', function(event) {
  const picker = event.target.querySelector('.GaleaBokFinishes');
  if (!picker) return;
  const priceList = event.target.querySelector('.ProductMeta__PriceList');
  const variant = event.detail.variant;
  if (!priceList) return;
  requestAnimationFrame(function() {
    priceList.style.display = variant ? '' : 'none';
    if (!variant) return;
    const amount = new Intl.NumberFormat(document.documentElement.lang || 'es-ES', {
      style: 'currency',
      currency: picker.dataset.currency || 'EUR'
    }).format(variant.price / 100);
    const price = priceList.querySelector('.Price');
    if (price) price.textContent = amount;
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["galea-butacas-swatches"] && !Shopify.designMode) return;
  try {
    function galeaBokInitialPrices() {
  document.querySelectorAll('.GaleaBokFinishes').forEach(function(picker) {
    const info = picker.closest('.Product__Info');
    const price = info && info.querySelector('.ProductMeta__PriceList .Price');
    if (price) price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'es-ES', {
      style: 'currency', currency: picker.dataset.currency || 'EUR'
    }).format(Number(picker.dataset.initialPrice) / 100);
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', galeaBokInitialPrices, { once: true });
} else {
  galeaBokInitialPrices();
}

document.addEventListener('variant:changed', function(event) {
  const picker = event.target.querySelector('.GaleaBokFinishes');
  if (!picker) return;
  const priceList = event.target.querySelector('.ProductMeta__PriceList');
  const variant = event.detail.variant;
  if (!priceList) return;
  requestAnimationFrame(function() {
    priceList.style.display = variant ? '' : 'none';
    if (!variant) return;
    const amount = new Intl.NumberFormat(document.documentElement.lang || 'es-ES', {
      style: 'currency',
      currency: picker.dataset.currency || 'EUR'
    }).format(variant.price / 100);
    const price = priceList.querySelector('.Price');
    if (price) price.textContent = amount;
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["galea-campeggi-color-swatches"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function(event) {
  const input = event.target;
  if (!input || !input.classList || !input.classList.contains('GaleaCampeggiRadio')) return;
  const picker = input.closest('.GaleaCampeggiFinishes');
  if (!picker) return;
  const caption = picker.querySelector('.ProductForm__SelectedValue');
  if (caption) caption.textContent = input.value;
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["galea-elements-swatches"] && !Shopify.designMode) return;
  try {
    function galeaElementsInitialPrices() {
  document.querySelectorAll('.GaleaElementsFinishes').forEach(function(picker) {
    const info = picker.closest('.Product__Info');
    const price = info && info.querySelector('.ProductMeta__PriceList .Price');
    const root = picker.closest('.Product');
    const initialThumbnail = root && root.querySelector('.Product__SlideshowNavImage[href="#Image' + picker.dataset.initialImage + '"]');
    if (initialThumbnail) requestAnimationFrame(function() { initialThumbnail.click(); });
    if (price) price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'es-ES', {
      style: 'currency', currency: picker.dataset.currency || 'EUR'
    }).format(Number(picker.dataset.initialPrice) / 100);
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', galeaElementsInitialPrices, { once: true });
} else {
  galeaElementsInitialPrices();
}

document.addEventListener('variant:changed', function(event) {
  const picker = event.target.querySelector('.GaleaElementsFinishes');
  if (!picker) return;
  const priceList = event.target.querySelector('.ProductMeta__PriceList');
  const variant = event.detail.variant;
  if (!priceList) return;
  requestAnimationFrame(function() {
    priceList.style.display = variant ? '' : 'none';
    if (!variant) return;
    const amount = new Intl.NumberFormat(document.documentElement.lang || 'es-ES', {
      style: 'currency',
      currency: picker.dataset.currency || 'EUR'
    }).format(variant.price / 100);
    const price = priceList.querySelector('.Price--highlight') || priceList.querySelector('.Price');
    if (price) price.textContent = amount;
    const compare = priceList.querySelector('.Price--compareAt');
    if (compare) {
      compare.textContent = new Intl.NumberFormat(document.documentElement.lang || 'es-ES', { style: 'currency', currency: picker.dataset.currency || 'EUR' }).format(variant.compare_at_price / 100);
      compare.style.display = variant.compare_at_price > variant.price ? '' : 'none';
    }
    if (variant.featured_image) {
      const productRoot = picker.closest('.Product');
      const thumbnail = productRoot && productRoot.querySelector('.Product__SlideshowNavImage[href="#Image' + variant.featured_image.id + '"]');
      if (thumbnail) thumbnail.click();
    }
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["galea-ethnicraft-swatches"] && !Shopify.designMode) return;
  try {
    function galeaEthnicraftPrice(picker,variant){
  const info=picker.closest('.Product__Info');
  const prices=info&&info.querySelector('.ProductMeta__PriceList');
  if(!prices)return;
  prices.style.display=variant?'':'none';
  if(!variant)return;
  const formatter=new Intl.NumberFormat(document.documentElement.lang||'es-ES',{style:'currency',currency:picker.dataset.currency||'EUR',minimumFractionDigits:0,maximumFractionDigits:2});
  const current=document.createElement('span');
  current.className='ProductMeta__Price Price Text--subdued u-h4';
  current.textContent=formatter.format(Number(variant.price)/100);
  prices.replaceChildren(current);
  if(Number(variant.compare_at_price)>Number(variant.price)){
    current.classList.add('Price--highlight');
    const previous=document.createElement('span');
    previous.className='ProductMeta__Price Price Price--compareAt Text--subdued u-h4';
    previous.textContent=formatter.format(Number(variant.compare_at_price)/100);
    prices.appendChild(previous);
  }
}
function galeaEthnicraftImage(input){
  if(!input||!input.dataset.finishImage)return;
  const root=input.closest('.Product');
  const productData=root&&root.querySelector('[data-product-json]');
  const variantSelector=root&&root.querySelector('.ProductForm [name="id"]');
  if(!productData||!variantSelector)return;
  const variants=JSON.parse(productData.textContent).product.variants;
  const current=variants.find(function(variant){return String(variant.id)===variantSelector.value;});
  if(!current||current.featured_image)return;
  const visualVariant=Object.assign({},current,{featured_image:{id:Number(input.dataset.finishImage)}});
  requestAnimationFrame(function(){root.dispatchEvent(new CustomEvent('variant:changed',{bubbles:true,detail:{variant:visualVariant,previousVariant:current}}));});
}
document.addEventListener('change',function(event){
  if(event.target.classList&&event.target.classList.contains('GaleaEthnicraftRadio'))galeaEthnicraftImage(event.target);
});
function galeaEthnicraftInitialPrices(){
  document.querySelectorAll('.GaleaEthnicraftFinishes').forEach(function(picker){
    galeaEthnicraftPrice(picker,{price:picker.dataset.initialPrice,compare_at_price:picker.dataset.initialCompare});
    galeaEthnicraftImage(picker.querySelector('.GaleaEthnicraftRadio:checked'));
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',galeaEthnicraftInitialPrices,{once:true});
else galeaEthnicraftInitialPrices();
if(document.readyState!=='complete')window.addEventListener('load',galeaEthnicraftInitialPrices,{once:true});
document.addEventListener('variant:changed',function(event){
  const picker=event.target.querySelector('.GaleaEthnicraftFinishes');
  if(picker)galeaEthnicraftPrice(picker,event.detail.variant);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["galea-marset-swatches"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change',function(event){
  const input=event.target;
  if(!input.classList||!input.classList.contains('GaleaMarsetRadio'))return;
  const picker=input.closest('.GaleaMarsetFinishes');
  const caption=picker&&picker.querySelector('.ProductForm__SelectedValue');
  if(caption)caption.textContent=input.value;
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["galea-n701-swatches"] && !Shopify.designMode) return;
  try {
    function galeaN701InitialPrices() {
  document.querySelectorAll('.GaleaN701Finishes').forEach(function(picker) {
    const info = picker.closest('.Product__Info');
    const price = info && info.querySelector('.ProductMeta__PriceList .Price');
    const root = picker.closest('.Product');
    const initialThumbnail = root && root.querySelector('.Product__SlideshowNavImage[href="#Image' + picker.dataset.initialImage + '"]');
    if (initialThumbnail) requestAnimationFrame(function() { initialThumbnail.click(); });
    if (price) price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'es-ES', {
      style: 'currency', currency: picker.dataset.currency || 'EUR'
    }).format(Number(picker.dataset.initialPrice) / 100);
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', galeaN701InitialPrices, { once: true });
} else {
  galeaN701InitialPrices();
}

document.addEventListener('variant:changed', function(event) {
  const picker = event.target.querySelector('.GaleaN701Finishes');
  if (!picker) return;
  const priceList = event.target.querySelector('.ProductMeta__PriceList');
  const variant = event.detail.variant;
  if (!priceList) return;
  requestAnimationFrame(function() {
    priceList.style.display = variant ? '' : 'none';
    if (!variant) return;
    const amount = new Intl.NumberFormat(document.documentElement.lang || 'es-ES', {
      style: 'currency',
      currency: picker.dataset.currency || 'EUR'
    }).format(variant.price / 100);
    const price = priceList.querySelector('.Price--highlight') || priceList.querySelector('.Price');
    if (price) price.textContent = amount;
    const compare = priceList.querySelector('.Price--compareAt');
    if (compare) {
      compare.textContent = new Intl.NumberFormat(document.documentElement.lang || 'es-ES', { style: 'currency', currency: picker.dataset.currency || 'EUR' }).format(variant.compare_at_price / 100);
      compare.style.display = variant.compare_at_price > variant.price ? '' : 'none';
    }
    if (variant.featured_image) {
      const productRoot = picker.closest('.Product');
      const thumbnail = productRoot && productRoot.querySelector('.Product__SlideshowNavImage[href="#Image' + variant.featured_image.id + '"]');
      if (thumbnail) thumbnail.click();
    }
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["galea-ondarreta-epoxi-property"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('galea-epoxi-property')) {
  customElements.define('galea-epoxi-property', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      if (!this.form) return;
      this.guard = event => {
        if (event.type === 'click' && !event.target.closest('button[type="submit"],input[type="submit"],[data-action="add-to-cart"]')) return;
        if (this.querySelector('input:checked')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.querySelector('[data-epoxi-error]').hidden = false;
        this.querySelector('input').reportValidity();
      };
      this.change = () => {
        const chosen = this.querySelector('input:checked');
        this.querySelector('[data-epoxi-selected]').textContent = chosen ? chosen.value : 'Elige un acabado';
        this.querySelector('[data-epoxi-error]').hidden = !!chosen;
      };
      this.form.addEventListener('click', this.guard, true);
      this.form.addEventListener('submit', this.guard, true);
      this.addEventListener('change', this.change);
    }
    disconnectedCallback() {
      if (!this.form) return;
      this.form.removeEventListener('click', this.guard, true);
      this.form.removeEventListener('submit', this.guard, true);
      this.removeEventListener('change', this.change);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["galea-ondarreta-extra-finishes"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('galea-extra-finishes')) {
  customElements.define('galea-extra-finishes', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      if (!this.form || this.bound) return;
      this.bound = true;
      this.groups = Array.from(this.querySelectorAll('[data-finish-group]'));
      this.sync = () => {
        this.groups.forEach(group => {
          const position = Number(group.dataset.optionPosition);
          const controls = position ? Array.from(this.form.querySelectorAll('[name="option-' + (position - 1) + '"]')) : [];
          const control = controls.find(input => input.type !== 'radio' || input.checked);
          const active = !position || (control && control.value === group.dataset.optionValue);
          group.hidden = !active;
          group.disabled = !active;
          group.querySelectorAll('input').forEach(input => { input.disabled = !active; input.required = !!active; });
          const selected = group.querySelector('input:checked');
          group.querySelector('[data-finish-selected]').textContent = selected ? selected.value : this.dataset.emptyLabel;
          if (!active || selected) group.querySelector('[data-finish-error]').hidden = true;
        });
      };
      this.guard = event => {
        if (event.type === 'click' && !event.target.closest('button[type="submit"],input[type="submit"],[data-action="add-to-cart"]')) return;
        this.sync();
        const missing = this.groups.find(group => !group.disabled && !group.querySelector('input:checked'));
        if (!missing) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        missing.querySelector('[data-finish-error]').hidden = false;
        const input = missing.querySelector('input');
        input.focus();
        input.reportValidity();
      };
      this.form.addEventListener('change', this.sync);
      this.form.addEventListener('variant:changed', this.sync);
      this.form.addEventListener('click', this.guard, true);
      this.form.addEventListener('submit', this.guard, true);
      this.sync();
    }
    disconnectedCallback() {
      if (!this.form || !this.bound) return;
      this.form.removeEventListener('change', this.sync);
      this.form.removeEventListener('variant:changed', this.sync);
      this.form.removeEventListener('click', this.guard, true);
      this.form.removeEventListener('submit', this.guard, true);
      this.bound = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["galea-ondarreta-pp-property"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('galea-pp-property')) {
  customElements.define('galea-pp-property', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      if (!this.form) return;
      this.guard = event => {
        if (event.type === 'click' && !event.target.closest('button[type="submit"],input[type="submit"],[data-action="add-to-cart"]')) return;
        if (this.querySelector('input:checked')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.querySelector('[data-pp-error]').hidden = false;
        this.querySelector('input').reportValidity();
      };
      this.change = () => {
        const chosen = this.querySelector('input:checked');
        this.querySelector('[data-pp-selected]').textContent = chosen ? chosen.value : 'Elige un acabado';
        this.querySelector('[data-pp-error]').hidden = !!chosen;
      };
      this.form.addEventListener('click', this.guard, true);
      this.form.addEventListener('submit', this.guard, true);
      this.addEventListener('change', this.change);
    }
    disconnectedCallback() {
      if (!this.form) return;
      this.form.removeEventListener('click', this.guard, true);
      this.form.removeEventListener('submit', this.guard, true);
      this.removeEventListener('change', this.change);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["galea-punt-swatches"] && !Shopify.designMode) return;
  try {
    const galeaPuntSelectedVariants=new WeakMap();
function galeaPuntPrice(picker,variant){
  const info=picker.closest('.Product__Info');
  const prices=info&&info.querySelector('.ProductMeta__PriceList');
  if(!prices)return;
  prices.style.display=variant?'':'none';
  if(!variant)return;
  const formatter=new Intl.NumberFormat(document.documentElement.lang||'es-ES',{style:'currency',currency:picker.dataset.currency||'EUR',minimumFractionDigits:0,maximumFractionDigits:2});
  const current=document.createElement('span');
  current.className='ProductMeta__Price Price Text--subdued u-h4';
  current.textContent=formatter.format(Number(variant.price)/100);
  prices.replaceChildren(current);
  if(Number(variant.compare_at_price)>Number(variant.price)){
    current.classList.add('Price--highlight');
    const previous=document.createElement('span');
    previous.className='ProductMeta__Price Price Price--compareAt Text--subdued u-h4';
    previous.textContent=formatter.format(Number(variant.compare_at_price)/100);
    prices.appendChild(previous);
  }
}
function galeaPuntInitialPrices(){
  document.querySelectorAll('.GaleaPuntFinishes').forEach(function(picker){
    const info=picker.closest('.Product__Info');
    const variant=info&&galeaPuntSelectedVariants.has(info)?galeaPuntSelectedVariants.get(info):{price:picker.dataset.initialPrice,compare_at_price:picker.dataset.initialCompare};
    galeaPuntPrice(picker,variant);
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',galeaPuntInitialPrices,{once:true});
else galeaPuntInitialPrices();
window.addEventListener('load',galeaPuntInitialPrices,{once:true});
document.addEventListener('change',function(event){
  if(!event.target.classList.contains('GaleaPuntRadio'))return;
  const picker=event.target.closest('.GaleaPuntFinishes');
  const selected=picker&&picker.querySelector('.ProductForm__SelectedValue');
  if(selected)selected.textContent=event.target.value;
});
document.addEventListener('variant:changed',function(event){
  const picker=event.target.querySelector('.GaleaPuntFinishes');
  if(picker){
    const info=picker.closest('.Product__Info');
    if(info)galeaPuntSelectedVariants.set(info,event.detail.variant);
    requestAnimationFrame(function(){galeaPuntPrice(picker,event.detail.variant);});
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["galea-sellex-axys-swatches"] && !Shopify.designMode) return;
  try {
    function galeaAxysPrice(picker,variant){
  const info=picker.closest('.Product__Info');
  const prices=info&&info.querySelector('.ProductMeta__PriceList');
  if(!prices)return;
  prices.style.display=variant?'':'none';
  if(!variant)return;
  const formatter=new Intl.NumberFormat(document.documentElement.lang||'es-ES',{style:'currency',currency:picker.dataset.currency||'EUR',minimumFractionDigits:0,maximumFractionDigits:2});
  const current=document.createElement('span');
  current.className='ProductMeta__Price Price Text--subdued u-h4';
  current.textContent=formatter.format(Number(variant.price)/100);
  prices.replaceChildren(current);
  if(Number(variant.compare_at_price)>Number(variant.price)){
    current.classList.add('Price--highlight');
    const previous=document.createElement('span');
    previous.className='ProductMeta__Price Price Price--compareAt Text--subdued u-h4';
    previous.textContent=formatter.format(Number(variant.compare_at_price)/100);
    prices.appendChild(previous);
  }
}
function galeaAxysInitialPrices(){
  document.querySelectorAll('.GaleaAxysFinishes').forEach(function(picker){
    galeaAxysPrice(picker,{price:picker.dataset.initialPrice,compare_at_price:picker.dataset.initialCompare});
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',galeaAxysInitialPrices,{once:true});
else galeaAxysInitialPrices();
window.addEventListener('load',galeaAxysInitialPrices,{once:true});
document.addEventListener('change',function(event){
  if(!event.target.classList.contains('GaleaAxysRadio'))return;
  const picker=event.target.closest('.GaleaAxysFinishes');
  const selected=picker&&picker.querySelector('.ProductForm__SelectedValue');
  if(selected)selected.textContent=event.target.value;
});
document.addEventListener('variant:changed',function(event){
  const picker=event.target.querySelector('.GaleaAxysFinishes');
  if(picker)requestAnimationFrame(function(){galeaAxysPrice(picker,event.detail.variant);});
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["galea-tradition-swatches"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change',function(event){
  var input=event.target;
  if(!input.classList||!input.classList.contains('GaleaTraditionRadio'))return;
  var picker=input.closest('.GaleaTraditionFinishes');
  var caption=picker&&picker.querySelector('.ProductForm__SelectedValue');
  if(caption)caption.textContent=input.value;
});

function galeaTraditionPrice(picker,variant){
  var info=picker.closest('.Product__Info')||picker.closest('[data-section-type="product"]');
  var prices=info&&info.querySelector('.ProductMeta__PriceList');
  if(!prices)return;
  if(!variant){prices.style.display='none';return;}
  var currency=picker.dataset.currency||'EUR';
  var formatter=new Intl.NumberFormat(document.documentElement.lang||'es-ES',{style:'currency',currency:currency,minimumFractionDigits:0,maximumFractionDigits:2});
  var current=document.createElement('span');
  current.className='ProductMeta__Price Price Text--subdued u-h4';
  current.setAttribute('data-money-convertible','');
  current.textContent=formatter.format(Number(variant.price)/100);
  prices.replaceChildren(current);
  if(Number(variant.compare_at_price)>Number(variant.price)){
    current.classList.add('Price--highlight');
    var previous=document.createElement('span');
    previous.className='ProductMeta__Price Price Price--compareAt Text--subdued u-h4';
    previous.setAttribute('data-money-convertible','');
    previous.textContent=formatter.format(Number(variant.compare_at_price)/100);
    prices.appendChild(previous);
  }
  prices.style.display='';
}
function galeaTraditionInitialPrices(){
  document.querySelectorAll('.GaleaTraditionFinishes').forEach(function(picker){
    galeaTraditionPrice(picker,{price:picker.dataset.initialPrice,compare_at_price:picker.dataset.initialCompare});
  });
}
if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',galeaTraditionInitialPrices,{once:true});
}else{galeaTraditionInitialPrices();}
document.addEventListener('variant:changed',function(event){
  var picker=event.target.querySelector('.GaleaTraditionFinishes');
  if(picker)galeaTraditionPrice(picker,event.detail.variant);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["galea-unda-swatches"] && !Shopify.designMode) return;
  try {
    document.addEventListener('variant:changed', function(event) {
  const picker = event.target.querySelector('.GaleaUndaFinishes');
  if (!picker) return;
  const priceList = event.target.querySelector('.ProductMeta__PriceList');
  const variant = event.detail.variant;
  if (!priceList) return;
  requestAnimationFrame(function() {
    priceList.style.display = variant ? '' : 'none';
    if (!variant) return;
    const amount = new Intl.NumberFormat(document.documentElement.lang || 'es-ES', {
      style: 'currency',
      currency: picker.dataset.currency || 'EUR'
    }).format(variant.price / 100);
    const price = priceList.querySelector('.Price');
    if (price) price.textContent = amount;
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["joquer-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = (root = document) => {
      root.querySelectorAll('[data-joquer-gallery-init]').forEach(marker => {
        if (marker.dataset.initialized) return;
        const section = marker.closest('[data-section-type="product"], [data-campeggi-product]');
        const slideshow = section?.querySelector('.Product__Slideshow');
        if (!slideshow) return;
        const slides = Array.from(slideshow.querySelectorAll('.Product__SlideItem'));
        const links = Array.from(section.querySelectorAll('.Product__SlideshowNav a[href^="#Image"]'));
        if (slides.length < 2 || !links.length) return;
        marker.dataset.initialized = 'true';
        const controller = new AbortController();
        const desktop = window.matchMedia('(min-width: 1008px)');
        const loads = new WeakMap();
        const exitTimers = new Map();
        const initial = slides.find(slide => slide.dataset.imageId === marker.dataset.initialImage) || slides[0];
        const imageRatio = slide => {
          const img = slide.querySelector('img');
          const ratio = Number(img?.dataset.maxWidth) / Number(img?.dataset.maxHeight);
          return Number.isFinite(ratio) && ratio > 0 ? ratio : 1;
        };
        const frameRatio = imageRatio(initial);
        slideshow.style.setProperty('--joquer-gallery-ratio', frameRatio);
        slides.forEach(slide => {
          slide.style.setProperty('--joquer-image-width', Math.min(1, imageRatio(slide) / frameRatio) * 100 + '%');
          slide.classList.toggle('is-joquer-selected', slide === initial);
        });
        const navigations = Array.from(section.querySelectorAll('.Product__SlideshowNav--thumbnails'));
        const oldTabIndexes = new Map(navigations.map(nav => [nav, nav.getAttribute('tabindex')]));
        let selectedId = initial.dataset.imageId;
        let pendingId = null;
        let request = 0;

        const loadImage = slide => {
          const img = slide.querySelector('img');
          if (!img) return Promise.resolve(false);
          img.loading = 'eager';
          if (loads.has(img)) return loads.get(img);
          const promise = new Promise(resolve => {
            const isRealSource = value => typeof value === 'string' && value.trim() !== ''
              && !/^(?:data:|blob:|about:|#)/i.test(value.trim())
              && !/\{width\}|\/(?:blank|transparent|spacer|placeholder)(?:[._-]|$)/i.test(value);
            let settled = false;
            let decoding = false;
            const finish = loaded => {
              if (settled) return;
              settled = true;
              img.removeEventListener('load', onReady);
              img.removeEventListener('lazyloaded', onReady);
              img.removeEventListener('error', onError);
              controller.signal.removeEventListener('abort', onError);
              if (loaded) img.classList.add('is-joquer-loaded');
              resolve(loaded);
            };
            const onReady = async () => {
              if (settled || decoding || !img.complete || img.naturalWidth <= 1 || !isRealSource(img.currentSrc || img.src)) return;
              decoding = true;
              const source = img.currentSrc || img.src;
              if (img.decode) {
                try { await img.decode(); } catch (_) { /* A responsive source may change during decoding. */ }
              }
              decoding = false;
              if (controller.signal.aborted) finish(false);
              else if (source !== (img.currentSrc || img.src)) onReady();
              else if (img.complete && img.naturalWidth > 1) finish(true);
              // If a responsive replacement is still loading, retain the listeners.
            };
            const onError = () => finish(false);
            img.addEventListener('load', onReady);
            img.addEventListener('lazyloaded', onReady);
            img.addEventListener('error', onError);
            controller.signal.addEventListener('abort', onError, {once: true});

            // Let the native loader build its responsive sources, but do not rely
            // on its deferred/no-op unveil to start a cold or placeholder image.
            try { window.lazySizes?.loader?.unveil?.(img); } catch (_) {}
            const hasSource = isRealSource(img.currentSrc) || isRealSource(img.getAttribute('src'));
            if (!hasSource || (img.complete && img.naturalWidth <= 1)) {
              const sourceSet = img.getAttribute('data-srcset');
              if (sourceSet && !/\{width\}/.test(sourceSet)) {
                const sizes = img.getAttribute('data-sizes');
                img.sizes = sizes && sizes !== 'auto' ? sizes : (img.clientWidth || slideshow.clientWidth || 800) + 'px';
                img.srcset = sourceSet;
              }
              const template = img.getAttribute('data-src') || img.getAttribute('data-original-src');
              if (template) {
                let widths = [];
                try { widths = JSON.parse(img.getAttribute('data-widths') || '[]'); } catch (_) {}
                const desired = Math.ceil((img.clientWidth || slideshow.clientWidth || 800) * Math.min(window.devicePixelRatio || 1, 2));
                const width = widths.find(value => value >= desired) || widths[widths.length - 1] || desired;
                img.src = template.replace(/\{width\}/g, width);
              } else if (!sourceSet) {
                finish(false);
              }
            }
            onReady();
          });
          loads.set(img, promise);
          promise.then(ok => { if (!ok) loads.delete(img); });
          return promise;
        };

        const updateNavigation = id => {
          links.forEach(link => {
            const active = link.hash === '#Image' + id;
            link.classList.toggle('is-selected', active);
            if (active) link.setAttribute('aria-current', 'true');
            else link.removeAttribute('aria-current');
          });
          const thumbnail = links.find(link => link.hash === '#Image' + id && link.classList.contains('Product__SlideshowNavImage'));
          const navigation = thumbnail?.closest('.Product__SlideshowNav--thumbnails');
          if (thumbnail && navigation) {
            const item = thumbnail.getBoundingClientRect();
            const viewport = navigation.getBoundingClientRect();
            if (item.top < viewport.top) navigation.scrollTop += item.top - viewport.top;
            else if (item.bottom > viewport.bottom) navigation.scrollTop += item.bottom - viewport.bottom;
          }
        };
        const selectImage = id => {
          const selected = slides.find(slide => slide.dataset.imageId === String(id));
          if (!selected) return false;
          selectedId = String(id);
          if (pendingId === selectedId) return true;
          pendingId = selectedId;
          const current = ++request;
          slides.forEach(slide => slide.classList.toggle('is-joquer-loading', slide === selected));
          // Establish the incoming layer at opacity zero, including cached images.
          selected.getBoundingClientRect();
          slideshow.setAttribute('aria-busy', 'true');
          loadImage(selected).then(loaded => {
            if (current !== request || !desktop.matches || controller.signal.aborted) return;
            pendingId = null;
            slideshow.removeAttribute('aria-busy');
            if (!loaded) {
              selected.classList.remove('is-joquer-loading');
              return;
            }
            slides.forEach(slide => {
              clearTimeout(exitTimers.get(slide));
              exitTimers.delete(slide);
              const leaving = slide !== selected && slide.classList.contains('is-joquer-selected');
              slide.classList.toggle('is-joquer-leaving', leaving);
              slide.classList.toggle('is-joquer-selected', slide === selected);
              slide.classList.remove('is-joquer-loading');
              if (leaving) exitTimers.set(slide, setTimeout(() => {
                slide.classList.remove('is-joquer-leaving');
                exitTimers.delete(slide);
              }, 220));
            });
            updateNavigation(selected.dataset.imageId);
          });
          return true;
        };
        const syncLayout = () => {
          ++request;
          pendingId = null;
          exitTimers.forEach(timer => clearTimeout(timer));
          exitTimers.clear();
          slides.forEach(slide => slide.classList.remove('is-joquer-loading', 'is-joquer-leaving'));
          section.classList.toggle('JoquerGallery--ready', desktop.matches);
          navigations.forEach(nav => {
            const old = oldTabIndexes.get(nav);
            if (desktop.matches && old === null) nav.setAttribute('tabindex', '0');
            else if (old === null) nav.removeAttribute('tabindex');
            else nav.setAttribute('tabindex', old);
          });
          if (desktop.matches) selectImage(selectedId);
          else slideshow.removeAttribute('aria-busy');
        };
        section.addEventListener('scrollspy:target:changed', event => {
          if (desktop.matches) event.stopImmediatePropagation();
        }, {capture: true, signal: controller.signal});
        section.addEventListener('click', event => {
          if (!desktop.matches || !(event.target instanceof Element)) return;
          const link = event.target.closest('.Product__SlideshowNav a[href^="#Image"]');
          if (!link || !section.contains(link)) return;
          if (selectImage(link.hash.slice(6))) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, {capture: true, signal: controller.signal});
        section.addEventListener('variant:changed', event => {
          const id = event.detail?.variant?.featured_image?.id;
          if (id) {
            selectedId = String(id);
            if (desktop.matches) selectImage(id);
          }
        }, {capture: true, signal: controller.signal});
        desktop.addEventListener('change', syncLayout, {signal: controller.signal});
        document.addEventListener('shopify:section:unload', event => {
          if (event.target.contains(section)) {
            controller.abort();
            exitTimers.forEach(timer => clearTimeout(timer));
          }
        }, {signal: controller.signal});
        syncLayout();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), {once: true});
    else initialize();
    document.addEventListener('shopify:section:load', event => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
